import "core-js/modules/es6.regexp.replace.js";
export default {
  props: {
    title: {
      type: Object,
      required: true
    },
    textColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      resolver: {
        heading1: 'h1',
        heading2: 'h2',
        heading3: 'h3',
        heading4: 'h4',
        heading5: 'h5',
        heading6: 'h6'
      }
    };
  },
  computed: {
    lineFeed() {
      return this.title.text ? this.title.text.replace(/\n/g, '<br />') : '';
    }
  }
};